import React, { useState } from 'react'
import CatGrooming from './CatGrooming';
import Faq from './Faq';
const serviceSteps = [
    {
        icon: "📝",
        title: "Schedule and book—all online",
        description: "All you have to do is pick a day and time",
    },
    {
        icon: "🔧",
        title: "Pet Groomer brings the equipment",
        description: "Professional pet groomer comes to your doorstep",
    },
    {
        icon: "🏠",
        title: "No travel stress for your pets",
        description: "Grooming service happens in your home",
    },
    {
        icon: "✅",
        title: "Groomer cleans up",
        description: "You're all set!",
    },
];
const services = [
    {
        icon: "🐕🛁",
        title: "Spa Bath",
        oldPrice: "₹1198",
        newPrice: "₹999",
        description: "Coupons Available on Mobile App. Download now→",
        button: "Book A Groomer",
        features: [
            "Bath With Shampoo & Conditioner",
            "Blow Dry",
            "Nail Clipping",
            "Ear Cleaning",
            "Eyes Cleaning",
            "Paw Massage",
            "Combing/Brushing",
        ],
    },
    {
        icon: "🐕🧼",
        title: "Bath + Basic Grooming",
        oldPrice: "₹1798",
        newPrice: "₹1499",
        description: "Coupons Available on Mobile App. Download now→",
        button: "Book A Groomer",
        features: [
            "Bath With Shampoo & Conditioner",
            "Blow Dry",
            "Face Haircutting",
            "Sanitary Trim",
            "Nail Clipping",
            "Ear Cleaning",
            "Eye Cleaning",
            "Teeth Cleaning/Mouth Spray",
            "Paw Massage",
            "Combing/Brushing",
        ],
    },
    {
        icon: "🐕✨", // Dog Full Service Icon
        title: "Full Service",
        oldPrice: "₹2398",
        newPrice: "₹1999",
        description: "Coupons Available on Mobile App. Download now→",
        button: "Book A Groomer",
        features: [
            "Bath With Shampoo & Conditioner",
            "Blow Dry",
            "Full body Trimming/Zero Haircut",
            "Eye Cleaning",
            "Ear Cleaning",
            "Body Massage",
            "Sanitary Trim",
            "Nail Clipping",
            "Teeth Cleaning/Mouth Spray",
            "Paw Massage",
            "Combing/Brushing",
        ],
    },
];

const PetGrooming = () => {
    const [selectedCity, setSelectedCity] = useState("bengaluru");

    const handleCityChange = (e) => {
        setSelectedCity(e.target.value);
        alert(`You selected: ${e.target.value}`);
    }
    return (
        <div>
            <div style={{ backgroundImage: 'url(./vet.jpg)', height: "600px", backgroundSize: 'cover' }}></div>
            <div className="border-2 border-slate-300 bg-white w-full sm:w-[80%] mt-[-100px] mx-auto">
                <main style={{ textAlign: "center", padding: "20px" }}>
                    <h1 className='text-4xl sm:text-5xl font-bold mt-7'>Pet Grooming Service at Your Doorstep</h1>
                    <p className='text-xl sm:text-2xl mt-5 text-gray-500'>
                        Instantly Book a Professional Pet Groomer Online, Whenever You Need One.
                    </p>
                    <button onClick={() => alert("Booking Groomer!")} className='bg-orange-500 mt-10 w-full sm:w-[400px] rounded-xl h-[60px] text-white font-bold text-xl'>
                        Book a Professional Groomer
                    </button>
                    <br />
                    <a href="#prices" className='text-blue-800 mt-4 inline-block'>Click here to check latest prices in your city</a>
                </main>
            </div>

            <div className='mt-10'>
                <p className='text-3xl text-center font-bold'>How Pet Grooming works at your home?</p>
                <div className='flex flex-col sm:flex-row items-center justify-center mt-10'>
                    <div className='sm:w-1/2'>
                        <img className='w-full h-auto sm:w-[500px] sm:h-[400px] object-cover' src="//dm6g3jbka53hp.cloudfront.net/static-images/grooming-puppy-30122019.jpg" alt="Grooming Puppy" />
                    </div>
                    <div className='sm:w-1/2 sm:ml-[40px]'>
                        {serviceSteps.map((step, index) => (
                            <div className='flex items-start mt-5' key={index}>
                                <div className='text-3xl'>{step.icon}</div>
                                <div className='ml-4'>
                                    <h1 className='text-xl font-semibold'>{step.title}</h1>
                                    <p className='text-sm'>{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='mt-14'>
                <iframe className='mx-auto' width="100%" maxWidth="1260" height="515" src="https://www.youtube.com/embed/zb8ap_5T7RQ?si=5bpq8qFzPu4rOxCq" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>

            <div className="bg-gray-100 py-10 mt-10">
                <h1 className="text-2xl text-center font-bold mb-4">Please select your city</h1>
                <div className="text-center">
                    <span className="">📍</span>
                    <select
                        value={selectedCity}
                        onChange={handleCityChange}
                        className="bg-transparent focus:outline-none w-full sm:w-72 h-10 border-2 border-gray-400"
                    >
                        <option value="bengaluru">Bengaluru</option>
                        <option value="mumbai">Mumbai</option>
                        <option value="delhi">Delhi</option>
                        <option value="chennai">Chennai</option>
                        <option value="kolkata">Kolkata</option>
                    </select>
                </div>
                <p className="mt-4 text-center text-gray-600">Selected City: {selectedCity}</p>
            </div>

            <p className='text-center text-4xl mt-10'>Dog Grooming Packages</p>
            <p className='text-center mt-8'>Charges may vary based on Pet and City.</p>
            <div className="container mx-auto px-4 grid gap-8 sm:grid-cols-2 lg:grid-cols-3 mt-10">
                {services.map((service, index) => (
                    <div key={index} className="bg-white rounded-lg shadow-lg p-6 flex flex-col justify-between text-center">
                        <div>
                            <div className="text-4xl">{service.icon}</div>
                            <h2 className="text-xl font-bold mt-4">{service.title}</h2>
                            <div className="mt-2">
                                <span className="line-through text-gray-500">{service.oldPrice}</span>{" "}
                                <span className="text-green-500 font-bold">{service.newPrice}</span>
                            </div>
                            <p className="text-sm text-gray-600 mt-2">{service.description}</p>
                        </div>
                        <ul className="text-left mt-4">
                            {service.features.map((feature, idx) => (
                                <li key={idx} className="flex items-center gap-2 text-sm mb-2">
                                    <span className="text-green-500">✔</span>
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                        <button
                            onClick={() => alert(`Booking for ${service.title}`)}
                            className="bg-orange-500 mt-4 w-full rounded-xl h-10 text-white font-bold text-sm"
                        >
                            {service.button}
                        </button>
                    </div>
                ))}
            </div>
            <CatGrooming/>
            <Faq/>
        </div>
    )
}

export default PetGrooming
